import { gql } from 'graphql-request'

export const GET_PENNAMES_BY_BANNER = gql`
  query GetPennamesByBanner($getPennamesByBannerId: Int!) {
    getPennamesByBanner(id: $getPennamesByBannerId) {
      id
      firstPenName
    }
  }
`
